
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CustomerDetailsFieldGroup from '@/components/fieldGroups/CustomerDetailsFieldGroup.vue';
import { UserDataAdvancedJB } from '@/models/main';
import { getReferencesParamsWrapper } from '@/helpers/booking';
import { clearPhoneNumber } from '@/utils/InputProcessingUtilities';
import { JobDetailedData } from '@/models/jobDetailed';

@Component({
  components: {
    CustomerDetailsFieldGroup,
  },
})
export default class CustomerDetailsFieldset extends Vue {
  @Prop(Object) public value: JobDetailedData;

  get detailedJob() {
    return this.value;
  }

  set detailedJob(value) {
    this.$emit('input', value);
  }

  private userDataDefault: UserDataAdvancedJB = {
    customerCode: '',
    caller: '',
    phone_number: '',
    reference1: '',
    reference2: '',
    reference3: '',
    ref1_prompt: 'Reference 1',
    ref2_prompt: 'Reference 2',
    ref3_prompt: 'Reference 3',
    ref1_required: false,
    ref2_required: false,
    ref3_required: false,
  };

  private userData: UserDataAdvancedJB = { ...this.userDataDefault };

  @Watch('userData', { immediate: true, deep: true })
  private watchUserData() {
    if (this.detailedJob) {
      this.detailedJob.customer = this.userData.customerCode;
      this.detailedJob.caller = this.userData.caller;
      this.detailedJob.phone = this.userData.phone_number;
      this.detailedJob.reference_1 = this.userData.reference1;
      this.detailedJob.reference_2 = this.userData.reference2;
      this.detailedJob.reference_3 = this.userData.reference3;
    }
  }

  @Watch('value', { immediate: true, deep: true })
  private watchDetailedJob() {
    if (this.detailedJob) {
      this.userData.customerCode = this.detailedJob.customer;
      this.userData.caller = this.detailedJob.caller;
      this.userData.phone_number = this.detailedJob.phone;
      this.userData.reference1 = this.detailedJob.reference_1;
      this.userData.reference2 = this.detailedJob.reference_2;
      this.userData.reference3 = this.detailedJob.reference_3;
    }
  }

  private setCustomerCode(stop, customerCode): void {
    if (customerCode) {
      this.userData.customerCode = customerCode;
    }
    getReferencesParamsWrapper(this.userData.customerCode, this.userData);
  }

  private onlyNumberAndSpaceBlur() {
    this.userData.phone_number = clearPhoneNumber(this.userData.phone_number);
  }
}
